import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      a {
        border-radius: ${theme.radius.sm};
        overflow: hidden;
        position: relative;
        display: inline-block;
      }
    `;
  }};
`;
